//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
SPLM.PID.PropertyType = Object.freeze({
    "Null" : "Null", "Index" : "Index", "UserAttribute" : "UserAttribute", "NeedAttribute" : "NeedAttribute", "FulfillmentAttribute" : "FulfillmentAttribute", "PipeStockAttribute" : "PipeStockAttribute", "PidTag" : "PidTag", "ParentRun" : "ParentRun", "Quantity" : "Quantity", "System" : "System", "RunAttribute" : "RunAttribute", "EquipmentAttribute" : "EquipmentAttribute"});

export default SPLM;